import { createReducer, on } from '@ngrx/store';
import {
  getQueryStrings,
  getQueryStringsFailure,
  getQueryStringsSuccess,
  setQueryStrings,
  createQueryString,
  createQueryStringSuccess,
  createQueryStringFailure,
  updateQueryString,
  updateQueryStringSuccess,
  updateQueryStringFailure,
  deleteQueryString,
  deleteQueryStringSuccess,
  deleteQueryStringFailure,
  resetQueryStringActionState
} from '../actions/querystring.action';

export interface queryStringState {
  queryStrings: any[];
  totalRecords: number;
  queryStringsLoading: boolean;
  queryStringsError: any;
  queryStringCreated: boolean;
  queryStringUpdated: boolean;
  queryStringDeleted: boolean;
  queryStringActionError: any;
  searchFields: any;
  datatableLoading: boolean;
}

export const initialState: queryStringState = {
  queryStrings: [],
  totalRecords: 0,
  queryStringsLoading: false,
  queryStringsError: null,
  queryStringCreated: false,
  queryStringUpdated: false,
  queryStringDeleted: false,
  queryStringActionError: null,
  searchFields: null,
  datatableLoading: false
};

export const queryStringReducer = createReducer(
  initialState,
  on(getQueryStrings, (state, { apiConstants, filter, reset }) => ({
    ...state,
    queryStringsLoading: true,
    queryStringsError: null,
    queryStrings: reset ? [] : state.queryStrings,
    totalRecords: reset ? 0 : state.totalRecords
  })),
  on(getQueryStringsSuccess, (state, { queryStrings, totalRecords, append }) => ({
    ...state,
    queryStrings: append ? [...state.queryStrings, ...(queryStrings || [])] : (queryStrings || []),
    totalRecords: totalRecords || 0,
    queryStringsLoading: false,
    queryStringsError: null
  })),
  on(getQueryStringsFailure, (state, { error }) => ({
    ...state,
    queryStringsLoading: false,
    queryStringsError: error
  })),
  on(setQueryStrings, (state, { queryStrings, totalRecords }) => ({
    ...state,
    queryStrings: queryStrings || [],
    totalRecords: totalRecords || 0,
    queryStringsLoading: false,
    queryStringsError: null
  })),
  on(createQueryString, (state, { apiConstants }) => ({
    ...state,
    queryStringActionError: null
  })),
  on(createQueryStringSuccess, (state, { queryString }) => ({
    ...state,
    queryStringCreated: true,
    queryStringActionError: null
  })),
  on(createQueryStringFailure, (state, { error }) => ({
    ...state,
    queryStringCreated: false,
    queryStringActionError: error
  })),
  on(updateQueryString, (state) => ({
    ...state,
    queryStringActionError: null
  })),
  on(updateQueryStringSuccess, (state, { queryString }) => {
    return {
      ...state,
      queryStringUpdated: true,
      queryStringActionError: null
    };
  }),
  on(updateQueryStringFailure, (state, { error }) => ({
    ...state,
    queryStringUpdated: false,
    queryStringActionError: error
  })),
  on(deleteQueryString, (state) => ({
    ...state,
    queryStringActionError: null
  })),
  on(deleteQueryStringSuccess, (state, { queryStringId }) => ({
    ...state,
    queryStrings: state.queryStrings.filter(qs => qs.sid !== queryStringId),
    totalRecords: state.totalRecords - 1,
    queryStringDeleted: true,
    queryStringActionError: null,
  })),
  on(deleteQueryStringFailure, (state, { error }) => ({
    ...state,
    queryStringDeleted: false,
    queryStringActionError: error
  })),
  on(resetQueryStringActionState, (state) => ({
    ...state,
    queryStringCreated: false,
    queryStringUpdated: false,
    queryStringDeleted: false,
    queryStringActionError: null
  }))
);
